/*
 * This is a central place to define test id structure
 */

export enum ElementType {
    Button = 'btn',
    Input = 'input',
    Link = 'link',
    Modal = 'modal',
    List = 'list',
    ListItem = 'list-item',
    Form = 'form',
    Card = 'card',
    Table = 'table',
    Row = 'row',
}

export enum UseCase {
    Orders = 'ord',
    ListOfServices = 'los',
}

export const createTestId = (elementType: string, useCase: string, id: string) => `${elementType}-${useCase}-${id}`;
